export { default } from './capitalize'
export * from './capitalize'
